import React from 'react';
import { isAragUser, isSolicitorUser } from "../../helpers/functions";
import { POLICY_SCHEDULE } from '../../helpers/constants'; 

const PolicyTabs = (props) => {
  return (
      <ul className="nav nav-justified noprintarea">
          {props.Store.activeTab === 'application' ?
              <li className="item-active"
                  onClick={() => props.SelectActiveTab('application')}>
                  <a >Application</a>
              </li>
              :
              <li
                  onClick={() => props.SelectActiveTab('application')}>
                  <a >Application</a>
              </li>
          }
          {props.Store.activeTab === 'overview' ?
              <li className="item-active"
                  onClick={() => props.SelectActiveTab('overview')}>
                  <a >Overview</a>
              </li>
              :
              <li
                  onClick={() => props.SelectActiveTab('overview')}>
                  <a >Overview</a>
              </li>
          }
          {props.Store.activeTab === 'documents' ?
              <li className="item-active"
                  onClick={() => props.SelectActiveTab('documents')}>
                  <a >Documents</a>
              </li>
              :
              (props.SelectedApp.policyStatus === 'Draft' && isSolicitorUser(props.User.loggedInUser.roles))?
                  <li className="item-disabled">
                      <a >Documents</a>
                  </li>
                  :
                  <li
                      onClick={() => props.SelectActiveTab('documents')}>
                      <a >Documents</a>
                  </li>
          }
          {props.Store.activeTab === 'update' ?
              <li className="item-active"
                  onClick={() => props.SelectActiveTab('update')}>
                  <a >Update</a>
              </li>
              :
              (props.SelectedApp.policyStatus === 'Draft' || (props.SelectedApp.policyStatus === 'Referred') ) ?
                  <li className="item-disabled">
                      <a >Update</a>
                  </li>
                  :
                  <li
                      onClick={() => props.SelectActiveTab('update')}>
                      <a >Update</a>
                  </li>
          }
          {props.Store.activeTab === 'policySchedule' ?
              <li className="item-active"
                  onClick={() => props.SelectActiveTab('policySchedule')}>
                  <a >Policy {POLICY_SCHEDULE}</a>
              </li>
              :
              (
                  props.SelectedApp.policyStatus !== 'Draft'
                  && props.SelectedApp.policyStatus !== 'Referred'
                  && props.SelectedApp.policyStatus !== 'Rejected'
              ) ?
                  <li
                      onClick={() => props.SelectActiveTab('policySchedule')}>
                      <a >Policy {POLICY_SCHEDULE}</a>
                  </li>
                  :
                  <li className="item-disabled">
                      <a >Policy {POLICY_SCHEDULE}</a>
                  </li>
          }
        {
          (props.User.loggedInUser.solicitorGroupAllowedToApplyForDisbursements || isAragUser(props.User.loggedInUser.roles) ) && (
            props.SelectedApp.policyStatus !== 'Draft' &&
            props.SelectedApp.policyStatus !== 'Referred'
          ) ?
            props.Store.activeTab === 'advancedDisbursements' ?
              <li className="item-active"
                  onClick={() => props.SelectActiveTab('advancedDisbursements')}>
                <a >Advance Disbursements</a>
              </li>
              :
              <li
                onClick={() => props.SelectActiveTab('advancedDisbursements')}>
                <a >Advance Disbursements</a>
              </li>
            :
            null
          }
          {props.Store.activeTab === 'pendingChanges' ?
              <li className="item-active"
                  onClick={() => props.SelectActiveTab('pendingChanges')}>
                  <a >{'Pending Changes'}</a>
              </li>
              :
              (props.SelectedApp.policyStatus === 'Live' || props.SelectedApp.policyStatus === 'Referred' )?
                  <li
                      onClick={() => props.SelectActiveTab('pendingChanges')}>
                      <a >{'Pending Changes'}</a>
                  </li>
                  :
                  <li className="item-disabled">
                      <a >{'Pending Changes'}</a>
                  </li>
          }
      </ul>
  )
};

export default PolicyTabs;